import ApiService from './_api.service'
import Filter from '@/models/restockingfilter.model'

const API_RESTOCKING_URL = '/v1/restocking/'

const RestockingService = {
    // Restocking
    read: async function(args) {
        let url = API_RESTOCKING_URL + '?'
        Object.keys(args).forEach(key => {
            if (args[key] != null) url += key + '=' + args[key] + '&'
        })

        return ApiService.get(url)
    },

    readSolicitationProd: async function(args){
        // queryParams += 'q=' +args.q + 'prod_id/'
        const url = API_RESTOCKING_URL + 'solicitation-amplitude/' + args.q
        return ApiService.get(url)
    },

    readDcNeeds: async function(args) {
        const url = API_RESTOCKING_URL + 'product/dc-needs/'

        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get(url + queryParams)
    },

    readBranchNeeds: async function(args) {
        const url = API_RESTOCKING_URL + 'product/branch-needs/'

        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get(url + queryParams)
    },

    readStoreDcNeeds: async function(args) {
        const url = API_RESTOCKING_URL + 'store/dc-needs/'

        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get(url + queryParams)
    },

    readStoreNeeds: async function(args) {
        const url = API_RESTOCKING_URL + 'store/branch-needs/'

        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get(url + queryParams)
    },

    // FILTERS
    createFilter: function(entity) {
        let data = new FormData()
        Object.keys(Filter.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.post(API_RESTOCKING_URL + 'filters/', data)
    },

    readFilters: function(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (key == 'node' && args[key] == null) return
                    queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get(API_RESTOCKING_URL + 'filters/' + queryParams)
    },

    updateFilter: async function(id, entity) {
        let data = new FormData()
        Object.keys(Filter.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.patch(
            API_RESTOCKING_URL + 'filters/' + id + '/',
            data
        )
    },

    deleteFilter: async function(id) {
        return ApiService.delete(API_RESTOCKING_URL + 'filters/' + id + '/')
    },

    likeFilter: async function(id) {
        return ApiService.patch(
            API_RESTOCKING_URL + 'filters/' + id + '/like/',
            null
        )
    },

    unlikeFilter: async function(id) {
        return ApiService.patch(
            API_RESTOCKING_URL + 'filters/' + id + '/unlike/',
            {}
        )
    },

    updateLastSeen: async function(id) {
        return ApiService.patch(
            API_RESTOCKING_URL + 'filters/' + id + '/update_last_seen/',
            {}
        )
    },

    readAmplitude: function(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (key == 'node' && args[key] == null) return
                    queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get(API_RESTOCKING_URL + 'amplitude/' + queryParams)
    },

    readAmplitudeById: async function(id) {
        if (!id) return
        return await ApiService.get(API_RESTOCKING_URL + 'amplitude/' + id)
    },

    createAmplitude: async function(data) {
        if (data) {
            return ApiService.post(API_RESTOCKING_URL + 'amplitude/', data)
        }
    },

    readColorAmplitude: function(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (key == 'node' && args[key] == null) return
                    queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get(
            API_RESTOCKING_URL + 'color-amplitude/' + queryParams
        )
    },

    saveManyColorAmplitude: function(entity) {
        let data = new FormData()
        Object.keys(entity).forEach(key => {
            if (key == 'node' && entity[key] == null) return
            if (entity[key] != null) data.set(key, entity[key])
        })
        return ApiService.post(
            API_RESTOCKING_URL + 'color-amplitude/save_many/',
            data
        )
    }
}

export default RestockingService
export { RestockingService }
